import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { HelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SnippetStepItem({
  item,
  label
}) {
  var _item$tooltip;
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsxs(View, {
      children: [item.description && /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: item.description
      }), /*#__PURE__*/_jsx(CopyTextArea, {
        use: "code",
        value: item.snippet,
        readOnly: true,
        textAreaProps: {
          resize: 'vertical',
          rows: Math.min(item.snippet.split('\n').length, 8)
        }
      })]
    })
  });
}